// extracted by mini-css-extract-plugin
export default {"Card":"📚19-10-2d7UkO","variant_outline":"📚19-10-2rDA6l","variant_glass":"📚19-10-2Ea1sd","shape_squared":"📚19-10-2qTEdr","shape_rounded":"📚19-10-2OfLgX","shape_pill":"📚19-10-2eULis"};